import { atom } from "recoil";

const navigationNameAtom = atom({
  key: "navigationNameState",
  default: sessionStorage.getItem("navigation") ?? "home",
});

export default navigationNameAtom;
